import { Component, ViewEncapsulation } from '@angular/core';
import { MainService } from '../../service/main.service'
import { ProfileService } from '../../../portal/service/profile.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

import {DataControlService} from '../../service/data-control.service'
import { SpinnerService } from '../../../shared/spinner.service';
import { MainService as MD_mainService } from '../../../md/service/main.service';
import { session } from '../../../../environments/environment.session'
import Swal from 'sweetalert2';

// import {ServicesService} from '../../service/services.service'
import { MainService as Portal_main } from '../../../portal/service/main.service';


@Component({
  selector: '[app-sdp-sidebar]',
  templateUrl: './sdp-sidebar.component.html',
  styleUrls: ['./sdp-sidebar.component.css']
})
export class SdpSidebarComponent {
  
  user_id: any;
  imgURL: any;
  erpUser: any;
  accInfo: any;
  hidden: any = true;
  assigned_compoment: any = []
  sidebar: any = new Object();
  //allLableShowObjHR={}
  userInfo = { emp_name: 'Ram Prasad', designation: 'Accountant' }
 
roles: any;
 
 

  constructor(private dataControlService:DataControlService,public Portal_main: Portal_main, private tspinner: SpinnerService, private router: Router,
    private profileService: ProfileService, private MD_mainService:MD_mainService, private sanitizer: DomSanitizer, public mainService: MainService ) {
  }

  async ngOnInit() {
    this.tspinner.show("", "")
    try{
      this.erpUser = JSON.parse(atob(session.erpUser));
    }catch(err){
    return
    }
   
    await this.dataControlService.getAllAssignedComponent(this.erpUser.b_acct_id, this.erpUser.role_cd, this.erpUser.account_short_name)
    this.tspinner.hide()
    this.erpUser = JSON.parse(atob(session.erpUser));
    this.user_id = this.erpUser.user_id;
    this.assigned_compoment = this.erpUser.assigned_component;
    await this.getcurrentroleswithresources()
    if (!this.assigned_compoment) {
      this.assigned_compoment = []
    }
    console.log(this.assigned_compoment)
    this.sidebar['Role'] = !this.assigned_compoment.includes('SDP-R1')
    this.sidebar['Admin Dashboard'] = !this.assigned_compoment.includes('SDP-R2')
    this.sidebar['Officer Dashboard'] = !this.assigned_compoment.includes('SDP-R3')
    this.sidebar['Operator Dashboard'] = !this.assigned_compoment.includes('SDP-R4')
    this.sidebar['User Management'] = !this.assigned_compoment.includes('SDP-R5')
    this.sidebar['Department Management'] = !this.assigned_compoment.includes('SDP-R6')
    this.sidebar['Escalation Matrix'] = !this.assigned_compoment.includes('SDP-R7')
    this.sidebar['Zone & Word Mapping'] = !this.assigned_compoment.includes('SDP-R8')
    this.sidebar['New Complaints'] = !this.assigned_compoment.includes('SDP-R9')
    this.sidebar['Complaints'] = !this.assigned_compoment.includes('SDP-R10')
    this.sidebar['Pending Complaints'] = !this.assigned_compoment.includes('SDP-R11')
    this.sidebar['Resolved Complaints'] = !this.assigned_compoment.includes('SDP-R12')
    this.sidebar['Search Complaints'] = !this.assigned_compoment.includes('SDP-R13')
    this.sidebar['Municipal Commissinor Dashboard'] = !this.assigned_compoment.includes('SDP-R14')
    this.sidebar['User Mapping'] = !this.assigned_compoment.includes('SDP-R15')
    this.sidebar['Hier'] = !this.assigned_compoment.includes('SDP-R16')
    this.sidebar['Role'] = !this.assigned_compoment.includes('SDP-R1')
    this.sidebar['Total Greviance'] = !this.assigned_compoment.includes('SDP-R18')
    this.sidebar['Today Greviance'] = !this.assigned_compoment.includes('SDP-R19')
    this.sidebar['Pending MC'] = !this.assigned_compoment.includes('SDP-R20')
    this.sidebar['Portal Profile'] = !this.assigned_compoment.includes('SDP-R21')

 
    this.user_id = this.erpUser.user_id;
    if (this.erpUser.is_admin == 0) {
      this.hidden = true;
    } else {
      this.hidden = false
    }
    this.imgURL = './assets/img/dash/ cfc.jpg';
    await this.getUserImage();
    await this.getAccImage();
  }


  
  home() {
    this.router.navigate(['/index'])
  }





  async getUserImage() {
    const res = await this.profileService.getImage(this.user_id);
    if (res) {
      const unsafeImageUrl = window.URL.createObjectURL(res); // URL.createObjectURL(res);
      this.imgURL = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
      this.mainService.profileImageUrl = this.imgURL;

    }
  }
  async getUserInfo() {
    this.tspinner.show("", "")
    var resp = await this.profileService.getUserProfileInfo(this.user_id);
    if (resp['error'] == false) {
      this.tspinner.hide()

      this.userInfo = resp.data[0];
    } else {

      this.tspinner.hide()
    }
  }
  async getAccImage() {
    const res = await this.profileService.getAccImage(this.erpUser.b_acct_id);
    if (res) {
      const unsafeImageUrl = window.URL.createObjectURL(res); // URL.createObjectURL(res);
      this.imgURL = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
      this.mainService.accountImageUrl = this.imgURL;

    }
  }
  async getAccInfo() {
    this.tspinner.show('', '')
    var resp = await this.profileService.getAccProfileInfo(this.erpUser.b_acct_id);
    if (resp['error'] == false) {
      this.tspinner.hide()
      this.accInfo = resp.data[0];
      this.mainService.accInfo = this.accInfo;
    } else {
      this.tspinner.hide()

    }

  }
 async getcurrentroleswithresources() {
    // this.tspinner.show('','');
    let obj:any = {}
    obj['b_acct_id'] = this.erpUser.b_acct_id
    console.log(obj)
    var resp = await this.MD_mainService.getcurrentroleswithresources(JSON.stringify(obj));
    console.log(resp);
    if (resp['error'] == false) {
      this.roles =null;

      for (let i = 0; i < resp.data.length; i++) {
        this.MD_mainService.moduleRoleObj[resp.data[i]['role_cd']] = resp.data[i]['role_name']
      }
      var role_cd = this.erpUser['role_cd'];

      for (let i = 0; i < role_cd.length; i++) {
        if(!['HR_EMP','CFC_EMP'].includes(role_cd[i])){
          if (!this.roles) {
            this.roles = this.MD_mainService.moduleRoleObj[role_cd[i]]
          } else {
            this.roles = this.roles + " , " + this.MD_mainService.moduleRoleObj[role_cd[i]]
          }
        }
     
      }
      // this.tspinner.hide()
    } else {
      // this.spinner.hide()
      // Swal.fire("Error", "..Error while getting  roles", 'error');
    }
  }
  Screen(value: any) {
    // return
    // this.ss.headerMess=value
  }


  refreshCol(value: any) {
    var col = document.getElementsByClassName('collapse')

    for (let i = 0; i <= col.length; i++) {
      if (col[i].classList.contains('show')) {
        col[i].classList.remove('show');
      }
    }

  }
async logOut(){
  
        sessionStorage.removeItem("1001");
        sessionStorage.removeItem("1000");
        sessionStorage.removeItem("1005");
        session.erpUser = undefined
        this.router.navigate(['/login']);
  
    }
}



